(function componentForm($, Adzuki)
{

	"use strict";

	var form = {
		name: 'MyTripsAccountClientTravelStyles',
	};

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load($form)
	{
		var $select = $('select#mytripsaccountclienttravelstyles-travel_style');

		$select.change(function changing() {
			$('#mytripsaccountclienttravelstyles-travel_style option').each(function selecting(index, option) {
				var $option = $(option);
				var styleId = $option.val();
				var $selectedSpan = $('.selected-travel-style[data-travel-style-id="' + styleId + '"]');

				if ($option.is(':selected')) {
					$selectedSpan.removeClass('hidden');
				} else {
					$selectedSpan.addClass('hidden');
				}
			});

			updateSelectedLabel();
		}).trigger('change');

		function updateSelectedLabel() {
			var $label = $('.selected-travel-styles-label');
			var selectedCount = $('.selected-travel-style:not(.hidden)').length;

			if (selectedCount > 0) {
				$label.removeClass('hidden');
			} else {
				$label.addClass('hidden');
			}
		}

		$('.reset-travel-styles').on('click', function resetTravelStyles(e) {
			e.preventDefault();
			$select.val('').trigger('change');
		});
	};

}(jQuery, window.Adzuki || {}));